import React, { useMemo, useState, useEffect } from 'react';
import Slider from 'react-slick';
import { useSelector } from 'react-redux';

import { SliderArrowNext, SliderArrowPrev } from 'common/SliderArrows/SliderArrows';
import { Container, Heading, GenericDiv, GenericP } from 'commonStyles';
import { OrangeBorder, MyBizBlogSubTitle } from '../../Style';
import * as S from './ProductVideosStyle';
import VideoModal from 'common/VideoPlayer/VideoPlayerModal';
import { urlParam } from 'UtilityComponents/Util';
import { trackClickEventSimple } from 'omnitures';
import { useAppContext } from '../../../../bizLanding/landingContext';
import { MYBIZ_LOGO_IMAGES, MODAL_NAMES, PATHS, MYBIZ_DEFAULT_LOGOS } from 'AppConstants';

const Modaldata = {
	title: '',
	img: null,
	imgstyle: null,
	btnTxt: null,
	customClass: 'videoModal'
};
const ProductVideo = ({ isMobile }) =>{
	const { bizModal, toggleModal } = useAppContext();
	const productVideoData = useSelector((state) => state.resource.productVideos || {});
	const { content, heading, subHeading } = productVideoData;
	const [videoLink, setVideoLink] = useState('');

	useEffect(() => {
		let videoUrl = urlParam('video');
		if (videoUrl) {
			toggleModal(MODAL_NAMES.PRODUCT_VIDEO);
			setVideoLink(videoUrl);
		}
	}, []);

	const settings = useMemo(() => ({
		arrows: true,
		swipeToSlide: true,
		speed: 500,
		infinite: false,
		rows: isMobile ? 1 : 2,
		slidesToShow: isMobile ? 1.2 : 2,
		slidesToScroll: isMobile ? 1 : 2,
		nextArrow: <SliderArrowNext isMobile={isMobile} customClass='bottomAlign leftCenetered' />,
		prevArrow: <SliderArrowPrev isMobile={isMobile} customClass='bottomAlign leftCenetered' />,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1.2,
					slidesToScroll: 1
				}
			}
		]
	}), [isMobile]);

	const handleVideo = (link, heading) => () => {
		trackClickEventSimple(heading + '_clicked');
		toggleModal(bizModal === MODAL_NAMES.PRODUCT_VIDEO ? false : MODAL_NAMES.PRODUCT_VIDEO);
		setVideoLink(link ? link : '');
	};

	const videoTile = (item, firstVideo, index) => {
		const { imgUrl, heading, subHeading, contentUrl } = item;
		return (
			<S.ProductVideoItem
				id={`videos${index}`}
				key={heading}
				onClick={handleVideo(contentUrl, heading)}
				firstVideo={firstVideo}
				itemscope itemtype={`${PATHS.SEO_SCHEMA_URL}/VideoObject`}>
				<meta itemProp='uploadDate' content='2020-06-02 T08:00:00+08:00' />
				<meta itemProp='duration' content='PT1M48S' />
				<meta itemProp='contentUrl' content={contentUrl} />
				<meta itemProp='regionsAllowed' content='ALL' />
				<S.ProductVideoOverlay>
					<S.PlayBtn />
				</S.ProductVideoOverlay>
				<img crossOrigin='anonymous' itemProp='thumbnailUrl' src={imgUrl} />
				<S.ProductVideoContent>
					<GenericP itemProp='name' margin_B='4' fsize='16px' color='#fff' f_weight='900'>
						{heading}
					</GenericP>
					<GenericP fsize='12px' color='#fff'>{subHeading}</GenericP>
				</S.ProductVideoContent>
			</S.ProductVideoItem>
		);
	};

	const renderProductVideos = () => {
		const firstVideo = content[0];
		const videos = !isMobile ? content.slice(1) : content;

		return (
			<S.ProductVideosContainer>
				{!isMobile && firstVideo &&
					<S.ProductVideoLeftGrid>
						{videoTile(firstVideo, true, -1)}
					</S.ProductVideoLeftGrid>}
				<S.ProductVideoRightGrid>
					<S.SliderOuterWrap>
						<Slider {...settings}>
							{videos && videos.map((item, index) => videoTile(item, !isMobile, index) )}
						</Slider>
					</S.SliderOuterWrap>
				</S.ProductVideoRightGrid>
			</S.ProductVideosContainer>
		);
	};

	return (
		<GenericDiv id={MODAL_NAMES.PRODUCT_VIDEO} bottom_P='50' top_P='50'>
			<Container>
				<OrangeBorder />
				<GenericDiv left_P={`${isMobile ? '16' : 'auto'}`}>
					<Heading
						fontSize={`${isMobile ? '24px' : '40px'}`}
						marBt={`${isMobile ? '8px' : '5px'}`}
						dangerouslySetInnerHTML={{ __html: heading }}
					/>
				</GenericDiv>
				<MyBizBlogSubTitle>
					{subHeading}
				</MyBizBlogSubTitle>
				{content && renderProductVideos()}
			</Container>
			{bizModal === MODAL_NAMES.PRODUCT_VIDEO && videoLink &&
				<VideoModal
					height='65vh'
					videoLink={videoLink}
					isMobile={isMobile}
					Modaldata={Modaldata}
					handleVideo={handleVideo()}
					mybizLogo={MYBIZ_LOGO_IMAGES.BY_MMT_LIGHT || MYBIZ_DEFAULT_LOGOS.BY_MMT_LIGHT}
				/>}

		</GenericDiv>
	);
};

export default ProductVideo;
